// @flow
import { convertInstagramPostsFromApi } from 'services/Social';
import type { ApiExecutorType } from 'types/ApiExecutorType';
import type { SocialContent } from 'types/SocialContent';

function InstagramApi(executor: ApiExecutorType) {
  return { fetchPosts };

  function fetchPosts(): Promise<Array<SocialContent>> {
    return executor.get(`rs_instagram.json`)
              .then(responses => {
                return responses && responses['data'].map(resp => convertInstagramPostsFromApi(resp));
              });
  }
}

export default InstagramApi;
